import type { ReactNode } from "react";

interface FilterPanelProps {
  regions: string[];
  years: number[];
  region: string;
  year: string;
  rating: string;
  onRegion: (value: string) => void;
  onYear: (value: string) => void;
  onRating: (value: string) => void;
  onReset: () => void;
}

const ratingOptions = [
  { value: "全部", label: "全部评分" },
  { value: "9", label: "9 分以上" },
  { value: "8", label: "8 - 9 分" },
  { value: "7", label: "7 - 8 分" },
];

function OptionRow({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="border-b border-background-200 py-4 last:border-b-0">
      <p className="mb-3 font-heading text-sm font-bold text-foreground-800">{label}</p>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

function Chip({
  active,
  children,
  onClick,
}: {
  active: boolean;
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-secondary-100 text-foreground-700 hover:bg-secondary-200"
      }`}
    >
      {children}
    </button>
  );
}

export default function FilterPanel({
  regions,
  years,
  region,
  year,
  rating,
  onRegion,
  onYear,
  onRating,
  onReset,
}: FilterPanelProps) {
  return (
    <div className="rounded-lg bg-background-50 p-5 ring-1 ring-background-200">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-2 font-heading text-base font-bold text-foreground-900">
          <i className="ri-filter-3-line text-primary-500" />
          筛选条件
        </p>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-accent-600"
        >
          重置
        </button>
      </div>

      <div className="mt-2">
        <OptionRow label="地区">
          <Chip active={region === "全部"} onClick={() => onRegion("全部")}>
            全部
          </Chip>
          {regions.map((item) => (
            <Chip key={item} active={region === item} onClick={() => onRegion(item)}>
              {item}
            </Chip>
          ))}
        </OptionRow>

        <OptionRow label="年份">
          <Chip active={year === "全部"} onClick={() => onYear("全部")}>
            全部
          </Chip>
          {years.map((item) => (
            <Chip key={item} active={year === String(item)} onClick={() => onYear(String(item))}>
              {item}
            </Chip>
          ))}
        </OptionRow>

        <OptionRow label="评分区间">
          {ratingOptions.map((item) => (
            <Chip key={item.value} active={rating === item.value} onClick={() => onRating(item.value)}>
              {item.label}
            </Chip>
          ))}
        </OptionRow>
      </div>
    </div>
  );
}